// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  // console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  // console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
  setTimeout(function () {
    $(".accordion.tab-detail").click(function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        var p = $(this).next();
        $(p).removeClass("active");
        setTimeout(function () {
          $(p).css("height", "0px");
        }, 500);
      } else {
        $(this).addClass("active");
        var p = $(this).next();
        $(p).addClass("active");
        setTimeout(function () {
          $(p).css("height", "auto");
        }, 500);
      }
    });
  }, 1000);
});
jQuery.noConflict();

jQuery(document).ready(function ($) {
  // var selectedData = $("#variant-selector").find(":selected").data("attribute-name");
  setTimeout(function () {
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }, 2000);
  $(".slider-for").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    useTransform: true,
    cssEase: "linear",
  });
  $(".slider-for").on("afterChange", function (event, slick, currentSlide) {
    var targetDot = $(".slider-for .slick-dots").find(".slick-active"); // Select the specific dot
    var container = $(".slider-for").find(".slick-dots"); // Reference the scrollable container
    container.animate(
      {
        scrollLeft: targetDot.position().left + container.scrollLeft(),
      },
      800
    );
  });
  var imageId = $("#variant-selector").find(":selected").data("imageid");
  var pos = 0;
  pos = parseInt($("[data-imageid='" + imageId + "']").data("slick-index"));
  console.log("posss", pos);
  jQuery(".slider-for").slick("slickGoTo", pos);
  // $(".product__primary-right .accordion.tab-detail")
  //   .filter(function () {
  //     return !$(this).closest(".item-description").length;
  //   })
  //   .first()
  //   .addClass("active");
  // $(".product__primary-right .panel")
  //   .filter(function () {
  //     return !$(this).closest(".item-description").length;
  //   })
  //   .first()
  //   .addClass("active")
  //   .css("height", "auto");
  let flagVariant = false;
  var width_outer = $(document).outerWidth();
  if (width_outer < 921) {
    $("a.lightbox-image[href]").each(function () {
      $(this).removeAttr("href");
      $(this).removeAttr("data-pswp-src");
      $(this).removeAttr("data-pswp-width");
      $(this).removeAttr("data-pswp-height");
      $(this).removeAttr("data-cropped");
    });
  }
  let lll = $(
    ".product__color-swatch-new.dynamic-variant-button-new.selected-new"
  ).data("option-value");
  $(".product__chip-new.dynamic-variant-button-new").each(function () {
    $(this).removeClass("showNew");
  });
  $(".custom-add-on option").each(function () {
    if ($(this).data("option1") == lll) {
      console.log($(this).data("option1"));
      console.log($(this).data("option2"));

      $(
        ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
          $(this).data("option2") +
          "']"
      ).each(function () {
        $(this).addClass("showNew");
      });
    }
  });
  var v3 = $(
    "[data-product-option='option3'] .dynamic-variant-button.selected"
  ).data("option-value");
  $(".upsell-select").each(function () {
    var pid = $(this).data("pid");
    op = $(this).find("option");
    console.log("vvv", v3);
    var selectedSize = "";
    v3 = v3.toLowerCase();
    var validSizes1 = [
      `5'3" x 7'7"`,
      `5'3" x 7'6"`,
      `5'2" x 7'5"`,
      `5'1" x 8'`,
      `5'-1" x 8'`,
      `4'-9" x 7'-10"`,
      `5'-2" x 7'-5"`,
      `5' x 8'`,
      `5'-3" x 7'-7"`,
      `5'-3" x 8'`,
      `5'-3" x 7'-3"`,
      `5' x 7'`,
    ];
    var validSizes2 = [`5' x 7'`];
    var validSizes3 = [
      `2'3" x 8'`,
      `2'2" x 8'`,
      `2' x 8'`,
      `2'-3" x 8'`,
      `2'-2" x 8'`,
      `2'-2" x 7'-10"`,
      `2' x 7'-10"`,
    ];
    var validSizes4 = [
      `3'11" x 6'`,
      `3'-11" x 6'`,
      `4'3" x 6'`,
      `4' x 6'`,
      `3'-11" x 5'-11"`,
      `4'-3" x 6'`,
    ];
    var validSizes5 = [
      `3' x 5'`,
      `3'1" x 5'`,
      `2'9" x 5'`,
      `3'-1" x 5'`,
      `2'-11" x 5'`,
      `3' x 4'9"`,
      `3'-3" x 4'-11"`,
      `2'-9" x 5'`,
      `2'-11" x 4'-11"`,
      `2'-9" x 4'-9"`,
      `3'-3" x 5'`,
    ];
    var validSizes6 = [
      `7'9" x 10'`,
      `7'8" x 10'`,
      `7'-8" x 10'`,
      `7'-9" x 10'`,
      `7'-10" x 10'`,
      `7'7"' x 10'2"`,
      `7'-10" x 10'-2"`,
      `8' x 10'`,
      `7'-10" x 9'-8"`,
    ];
    var validSizes7 = [`2'3" x 10'`, `2'2" x 10'`, `2' x 10'`, `2'-2" x 10'`];
    var validSizes9 = [
      `8'8" x 12'`,
      `8'9" x 12'`,
      `9' x 12'`,
      `8'-8" x 12'`,
      `8'-10" x 12'`,
      `8'-9" x 11'-8"`,
      `8'-9" x 12'`,
    ];
    var validSizes10 = [`10' x 14'`];
    var validSizes11 = [`12' x 15'`];
    var validSizes12 = [`6'2" x 9'`, `6' x 9'`, `6'-7" x 9'`];
    var validSizes13 = [`12' x 18'`];
    if (validSizes1.includes(v3)) {
      selectedSize = "5 X 8";
      console.log("Valid size detected: " + v3);
      // Your condition logic here
    } else if (validSizes2.includes(v3)) {
      selectedSize = "5 X 7";
      console.log("Valid size detected: " + v3);
    } else if (validSizes3.includes(v3)) {
      selectedSize = "2 X 8";
      console.log("Valid size detected: " + v3);
    } else if (validSizes4.includes(v3)) {
      selectedSize = "4 X 6";
      console.log("Valid size detected: " + v3);
    } else if (validSizes5.includes(v3)) {
      selectedSize = "3 X 5";
      console.log("Valid size detected: " + v3);
    } else if (validSizes6.includes(v3)) {
      selectedSize = "8 X 10";
      console.log("Valid size detected: " + v3);
    } else if (validSizes7.includes(v3)) {
      selectedSize = "2 X 10";
      console.log("Valid size detected: " + v3);
    } else if (validSizes9.includes(v3)) {
      selectedSize = "9 X 12";
      console.log("Valid size detected: " + v3);
    } else if (validSizes10.includes(v3)) {
      selectedSize = "10 X 14";
      console.log("Valid size detected: " + v3);
    } else if (validSizes11.includes(v3)) {
      selectedSize = "12 X 15";
      console.log("Valid size detected: " + v3);
    } else if (validSizes12.includes(v3)) {
      selectedSize = "6 X 9";
      console.log("Valid size detected: " + v3);
    } else if (validSizes13.includes(v3)) {
      selectedSize = "12 X 18";
      console.log("Valid size detected: " + v3);
    } else {
      console.log("Size not valid");
      $(".upsell-input.rug-upsell[data-product-id='" + pid + "']").attr(
        "disabled",
        true
      );
    }
    if (selectedSize != "") {
      op.each(function () {
        var option = $(this);
        var text = option.text();
        var value = option.val();
        var dataAttribute1 = option.data("op1");
        console.log("v3", v3);
        var dataAttributeSize = option.data("size-label");
        if (selectedSize == dataAttributeSize) {
          var upsell_price = option.data("price-addon");
          var pid = option.data("pid");
          window.theme = window.theme || {}; // Ensure window.theme exists
          $("#upsell-price-" + pid + "").html(
            window.theme.formatMoney(upsell_price)
          );

          $(this).attr("selected", true);
          if ($(this).data("available") == true) {
            $(".upsell-input[data-product-id='" + pid + "']").attr(
              "disabled",
              false
            );
          } else {
            $(".upsell-input[data-product-id='" + pid + "']").attr(
              "disabled",
              true
            );
          }
        }
      });
    }
  });

  document.addEventListener("product:variant-change", function (evt) {
    if (evt.detail.variant != null) {
      console.log("hett", evt.detail.variant);
      var imageId = evt.detail.variant.featured_media.id;
      var pos = 0;
      pos = parseInt($("[data-imageid='" + imageId + "']").data("slick-index"));
      console.log("posss", pos);
      jQuery(".slider-for").slick("slickGoTo", pos);

      if (evt.detail.variant != null && evt.detail.variant.sku) {
        $("#item_id").val(evt.detail.variant.sku);
      }
      var v3;
      if (evt.detail.variant.option3 != null) {
        v3 = evt.detail.variant.option3;
      } else if (evt.detail.variant.option2 != null) {
        v3 = evt.detail.variant.option2;
      }
      const notifyMain = document.querySelector(".notify-main");
      if (notifyMain) {
        if (evt.detail.variant.available == false) {
          document.querySelector(".notify-main").style.display = "block";
        } else {
          document.querySelector(".notify-main").style.display = "none";
        }
      }
      var dimension = document.getElementById("dimensions-enable");
      var dataValue = dimension.getAttribute("data-value");
      if (dataValue == "true") {
        var allRows = document.querySelectorAll(".size-info-ext");
        allRows.forEach((row) => {
          row.classList.remove("active");
        });
        let extId = "ext-" + evt.detail.variant.id;
        let activeRow = document.getElementById(extId);
        if (activeRow) {
          activeRow.classList.add("active");
        }
      }
      var sizeCustom = document.getElementById("size-enable");
      var dataValueSize = sizeCustom.getAttribute("data-value");
      if (dataValueSize == "true") {
        var allRowsNew = document.querySelectorAll(".variant-info-row");
        allRowsNew.forEach((row) => {
          row.classList.remove("active");
        });
        var extIdNew = ".info-" + evt.detail.variant.id;
        var activeRowSelected = document.querySelectorAll(extIdNew);
        activeRowSelected.forEach((row) => {
          row.classList.add("active");
        });
      }
      // var variantvideo = document.getElementById("variant-video-enable");
      // var dataValueVideo = dimension.getAttribute("data-value");

      // if (dataValueVideo == "true") {
      //   var allVids = document.querySelectorAll(".varaint-meta-video");
      //   let ids = 0;

      //   allVids.forEach((row) => {
      //     ids = parseInt(row.getAttribute("data-product-id"));

      //     if (evt.detail.variant.id == ids) {
      //       console.log("heyy");
      //       let vid = row.getAttribute("data-video");
      //       console.log(vid);
      //       if (vid != "") {
      //         var videoElement = document.getElementById("home_video_variant");
      //         // Change the video source
      //         videoElement.src = vid;

      //         // Optionally reload the video for the new source to be applied
      //         videoElement.load();

      //         // Play the new video
      //         videoElement.play();
      //       }
      //     }
      //   });
      // }
      const upsellInput = document.querySelector(".upsell-input");
      if (upsellInput) {
        var op;
        var sizeValueMain = getSizeLabelByValue(evt.detail.variant.id);
        var anyOne = true;
        $(".upsell-select").each(function () {
          anyOne = true;
          var pid = $(this).data("pid");
          op = $(this).find("option");
          op.each(function () {
            var option = $(this);
            var text = option.text();
            var value = option.val();
            var dataAttribute1 = option.data("op1");
            console.log("v3", v3);
            if (option.data("op3") == v3) {
              var upsell_price = option.data("price-addon");
              var pid = option.data("pid");

              window.theme = window.theme || {}; // Ensure window.theme exists
              $("#upsell-price-" + pid + "").html(
                window.theme.formatMoney(upsell_price)
              );

              $(this).attr("selected", true);
              anyOne = false;
              if ($(this).data("available") == true) {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  false
                );
              } else {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  true
                );
              }
            }
            var dataAttributeSize = option.data("size-label");
            console.log("sizeValueMain", sizeValueMain);
            console.log("dataAttributeSize", dataAttributeSize);
            if (sizeValueMain == option.data("op3")) {
              var upsell_price = option.data("price-addon");
              var pid = option.data("pid");

              window.theme = window.theme || {}; // Ensure window.theme exists
              $("#upsell-price-" + pid + "").html(
                window.theme.formatMoney(upsell_price)
              );

              $(this).attr("selected", true);
              anyOne = false;
              if ($(this).data("available") == true) {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  false
                );
              } else {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  true
                );
              }
            }
            if (sizeValueMain == dataAttributeSize) {
              var upsell_price = option.data("price-addon");
              var pid = option.data("pid");

              window.theme = window.theme || {}; // Ensure window.theme exists
              $("#upsell-price-" + pid + "").html(
                window.theme.formatMoney(upsell_price)
              );

              $(this).attr("selected", true);
              anyOne = false;

              if ($(this).data("available") == true) {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  false
                );
              } else {
                $(".upsell-input[data-product-id='" + pid + "']").attr(
                  "disabled",
                  true
                );
              }
            }
          });
          if (anyOne == true) {
            console.log("vvv", v3);
            var selectedSize = "";
            v3 = v3.toLowerCase();
            var validSizes1 = [
              `5'3" x 7'7"`,
              `5'3" x 7'6"`,
              `5'2" x 7'5"`,
              `5'1" x 8'`,
              `5'-1" x 8'`,
              `4'-9" x 7'-10"`,
              `5'-2" x 7'-5"`,
              `5' x 8'`,
              `5'-3" x 7'-7"`,
              `5'-3" x 8'`,
              `5'-3" x 7'-3"`,
              `5' x 7'`,
            ];
            var validSizes2 = [`5' x 7'`];
            var validSizes3 = [
              `2'3" x 8'`,
              `2'2" x 8'`,
              `2' x 8'`,
              `2'-3" x 8'`,
              `2'-2" x 8'`,
              `2'-2" x 7'-10"`,
              `2' x 7'-10"`,
            ];
            var validSizes4 = [
              `3'11" x 6'`,
              `3'-11" x 6'`,
              `4'3" x 6'`,
              `4' x 6'`,
              `3'-11" x 5'-11"`,
              `4'-3" x 6'`,
            ];
            var validSizes5 = [
              `3' x 5'`,
              `3'1" x 5'`,
              `2'9" x 5'`,
              `3'-1" x 5'`,
              `2'-11" x 5'`,
              `3' x 4'9"`,
              `3'-3" x 4'-11"`,
              `2'-9" x 5'`,
              `2'-11" x 4'-11"`,
              `2'-9" x 4'-9"`,
              `3'-3" x 5'`,
            ];
            var validSizes6 = [
              `7'9" x 10'`,
              `7'8" x 10'`,
              `7'-8" x 10'`,
              `7'-9" x 10'`,
              `7'-10" x 10'`,
              `7'7"' x 10'2"`,
              `7'-10" x 10'-2"`,
              `8' x 10'`,
              `7'-10" x 9'-8"`,
            ];
            var validSizes7 = [
              `2'3" x 10'`,
              `2'2" x 10'`,
              `2' x 10'`,
              `2'-2" x 10'`,
            ];
            var validSizes9 = [
              `8'8" x 12'`,
              `8'9" x 12'`,
              `9' x 12'`,
              `8'-8" x 12'`,
              `8'-10" x 12'`,
              `8'-9" x 11'-8"`,
              `8'-9" x 12'`,
            ];
            var validSizes10 = [`10' x 14'`];
            var validSizes11 = [`12' x 15'`];
            var validSizes12 = [`6'2" x 9'`, `6' x 9'`, `6'-7" x 9'`];
            var validSizes13 = [`12' x 18'`];
            if (validSizes1.includes(v3)) {
              selectedSize = "5 X 8";
              console.log("Valid size detected: " + v3);
              // Your condition logic here
            } else if (validSizes2.includes(v3)) {
              selectedSize = "5 X 7";
              console.log("Valid size detected: " + v3);
            } else if (validSizes3.includes(v3)) {
              selectedSize = "2 X 8";
              console.log("Valid size detected: " + v3);
            } else if (validSizes4.includes(v3)) {
              selectedSize = "4 X 6";
              console.log("Valid size detected: " + v3);
            } else if (validSizes5.includes(v3)) {
              selectedSize = "3 X 5";
              console.log("Valid size detected: " + v3);
            } else if (validSizes6.includes(v3)) {
              selectedSize = "8 X 10";
              console.log("Valid size detected: " + v3);
            } else if (validSizes7.includes(v3)) {
              selectedSize = "2 X 10";
              console.log("Valid size detected: " + v3);
            } else if (validSizes9.includes(v3)) {
              selectedSize = "9 X 12";
              console.log("Valid size detected: " + v3);
            } else if (validSizes10.includes(v3)) {
              selectedSize = "10 X 14";
              console.log("Valid size detected: " + v3);
            } else if (validSizes11.includes(v3)) {
              selectedSize = "12 X 15";
              console.log("Valid size detected: " + v3);
            } else if (validSizes12.includes(v3)) {
              selectedSize = "6 X 9";
              console.log("Valid size detected: " + v3);
            } else if (validSizes13.includes(v3)) {
              selectedSize = "12 X 18";
              console.log("Valid size detected: " + v3);
            } else {
              console.log("Size not valid");
              $(".upsell-input.rug-upsell[data-product-id='" + pid + "']").attr(
                "disabled",
                true
              );
            }
            if (selectedSize != "") {
              op.each(function () {
                var option = $(this);
                var text = option.text();
                var value = option.val();
                var dataAttribute1 = option.data("op1");
                console.log("v3", v3);
                var dataAttributeSize = option.data("size-label");
                if (selectedSize == dataAttributeSize) {
                  var upsell_price = option.data("price-addon");
                  var pid = option.data("pid");
                  window.theme = window.theme || {}; // Ensure window.theme exists
                  $("#upsell-price-" + pid + "").html(
                    window.theme.formatMoney(upsell_price)
                  );

                  $(this).attr("selected", true);
                  if ($(this).data("available") == true) {
                    $(".upsell-input[data-product-id='" + pid + "']").attr(
                      "disabled",
                      false
                    );
                  } else {
                    $(".upsell-input[data-product-id='" + pid + "']").attr(
                      "disabled",
                      true
                    );
                  }
                }
              });
            }
          }
        });
      }
      var joinTitle = getJoinLabelByValue(evt.detail.variant.id);

      if (joinTitle != null && flagVariant == false) {
        $(".product__chip-new.dynamic-variant-button-new").each(function () {
          $(this).removeClass("show");
        });

        var options = $(".join-product-contents").find(".product__option");
        var op = joinTitle.split(" / ");
        var k;
        $(op).each(function (index, value) {
          var opval = value;
          if (index == 0) {
            k = opval;
          }
          $(options)
            .find("button")
            .each(function () {
              if ($(this).data("option-value") == opval) {
                $(options).find("button.selected").removeClass("selected-new");
                $(this).click();
                $(
                  ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
                    opval +
                    "']"
                ).each(function () {
                  $(this).addClass("show");
                });
              }
            });
        });
        $(".product__chip-new.dynamic-variant-button-new").each(function () {
          $(this).removeClass("showNew");
        });

        $(".custom-add-on option").each(function () {
          if ($(this).data("option1") == k) {
            $(
              ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
                $(this).data("option2") +
                "']"
            ).each(function () {
              $(this).addClass("showNew");
            });
          }
        });
      }
    }
  });

  $(".dynamic-variant-button-new").click(function () {
    let hasColorS = $(this).hasClass("product__color-swatch-new");
    $(".product__chip-new.dynamic-variant-button-new").each(function () {
      $(this).removeClass("showNew");
    });

    $(".dynamic-variant-button-new")
      .not(".product__color-swatch-new")
      .each(function () {
        $(this).removeClass("show");
      });

    var p = $(this).parent();
    var ind = $(p).data("index");
    var childs = $(p).find(".selected-new");
    var id = $(this).data("id");
    $(childs).each(function () {
      $(this).removeClass("selected-new");
    });
    $(this).addClass("selected-new");
    var t = [];
    $(".selected-new").each(function () {
      t.push($(this).data("option-value"));
    });
    var pp = $(p).parent();
    var label = $(".join-product-contents").find(
      "span[data-option-name='" + ind + "']"
    );
    $(label).html($(this).data("option-value"));
    var k = t[0];
    v_title = t.join(" / ");

    $(".custom-add-on option").each(function () {
      $(this).prop("selected", false);
      if ($(this).data("option1") == k) {
        $(
          ".product__chip-new.dynamic-variant-button-new[data-option-value='" +
            $(this).data("option2") +
            "']"
        ).each(function () {
          $(this).addClass("showNew");
        });
      }
      if ($(this).data("variant") == v_title) {
        $(this).prop("selected", true);
        var l = $(this).val();
        $(".custom-add-on").trigger("change");
        $(".custom-add-on").val(l);
        var av = $(this).data("available");
        var prcjoin = $(this).data("price-join");
        var prccompare = $(this).data("compare-price-join");
        $(".price-add-compare-" + id + "").html(prccompare);
        $(".price-add-sale-" + id + "").html(prcjoin);
        if (av == false) {
          $(".dynamic-variant-button-new").each(function () {
            $(this).removeClass("is--soldout");
          });
          $(".dynamic-variant-button-new.selected-new").each(function () {
            $(this).addClass("is--soldout");
          });
        } else {
          $(".dynamic-variant-button-new").each(function () {
            $(this).removeClass("is--soldout");
          });
        }
      }
    });
    var checked_size = false;
    var prcjoin, prcjoincmp;
    if (flagVariant == false) {
      flagVariant = true;
      $(".v-option option").each(function () {
        if (v_title == $(this).data("join-title")) {
          prcjoin = parseInt($(this).data("p")) + parseInt($(this).data("op"));
          prcjoincmp =
            parseInt($(this).data("cm")) + parseInt($(this).data("cmpop"));
          var m_t = $(this).data("variant");
          var k = $(".product__color-swatch.selected").data("option-value");
          var m_values = m_t.split(" / ");
          if (m_t.indexOf(k) != -1) {
            $(m_values).each(function (i, v) {
              checked_size = true;
              $("[data-option-value='" + v + "']").click();
            });
          }
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 100);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 200);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 500);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 900);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
          }, 1000);
          setTimeout(function () {
            if (prcjoincmp > prcjoin) {
              $("[data-compare-price]").html(
                window.theme.formatMoney(prcjoincmp)
              );
            }
            $("[data-price]").html(window.theme.formatMoney(prcjoin));
            flagVariant = false;
          }, 1100);
        }
      });
    }
    if (hasColorS == true && checked_size == false) {
      $(".product__chip-new.dynamic-variant-button-new.showNew")
        .first()
        .click();
    }
  });
  function getSizeLabelByValue(value) {
    const opti = document.querySelector(
      `#variant-selector option[value="${value}"]`
    );
    if (opti) {
      return opti.getAttribute("data-size-label");
    }
    return null; // return null if no matching option is found
  }
  function getJoinLabelByValue(value) {
    const opti = document.querySelector(
      `#variant-selector option[value="${value}"]`
    );
    if (opti) {
      return opti.getAttribute("data-join-title");
    }
    return null; // return null if no matching option is found
  }
  $(".main-prd-btn").click(function () {
    var inputs = $(".custom-add-on").val();
    let cartData = {
      items: [], // Initialize an empty array for items
    };
    cartData.items.push({
      id: inputs,
      quantity: 1,
    });

    setTimeout(function () {
      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(cartData),
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json(); // Get the updated cart data
          } else {
            console.error("Failed to add products to cart!");
            // return Promise.reject(new Error('Failed to add products'));
          }
        })
        .then((data1) => {
          var data = data1.items[0];
          console.log("data", data);
          const event = new CustomEvent("quick-cart:updated", { data1 });
          document.dispatchEvent(event);
        })
        .catch((error) => {});
      setTimeout(function () {
        const event1 = new CustomEvent("quick-cart:updated");
        document.dispatchEvent(event1);
        $(".quick-cart__wrapper").addClass("active");
        $(".quick-cart").removeClass("animation");
      }, 1000);
      setTimeout(function () {
        var eve = new CustomEvent("quick-cart:updated");
        document.dispatchEvent(eve);
      }, 2000);
    }, 1000);
  });

  $(".open-modal").click(function () {
    var pageName = $(this).data("open-page");
    $(".t4s-close-overlay").addClass("is--visible");
    $("html").addClass("static-page-popup");
    $.ajax({
      url: "/pages/" + pageName,
      type: "GET",
      dataType: "json",
      success: function (data) {
        $("#modal_content_page").html(data.page.body_html);
        $("#light-guide").find(".t4s-modal").show();
      },
    });
  });
  $(".t4s-close-overlay").click(function () {
    $(".t4s-close-overlay").removeClass("is--visible");
    $("#light-guide").find(".t4s-modal").hide();
    $("html").removeClass("static-page-popup");
  });
  $(".t4s-modal-close").click(function () {
    $(".t4s-close-overlay").removeClass("is--visible");
    $("#light-guide").find(".t4s-modal").hide();
    $("html").removeClass("static-page-popup");
  });
  $("body").on("click", ".filter-item--toggle-more", function (e) {
    e.preventDefault();
    console.log("hii");
    var t = $(this).find("p").html();
    var t1 = t.replace(/^\s+|\s+$/gm, "");

    if (t1 == "See more") {
      $(this).find("p").html("See less");
      var p = $(this).parent();
      var links_child = $(p).find("li");
      $(links_child).each(function () {
        $(this).removeClass("filter-item--hidden");
      });
    } else {
      $(this).find("p").html("See more");
      var p = $(this).parent();
      var links_child = $(p).find("li");

      $(links_child).each(function (i, data) {
        if (i > 4) {
          $(this).addClass("filter-item--hidden");
        }
      });
      $(this).removeClass("filter-item--hidden");
    }
  });

  $(".upsell-input").change(function () {});
  $(".add-on-present").click(function (e) {
    var inputs = $(".upsell-input:checked");
    let cartData = {
      items: [], // Initialize an empty array for items
    };
    $(inputs).each(function () {
      v = $(this);
      cartData.items.push({
        id: $("#item-" + $(this).data("product-id") + "").val(),
        quantity: 1,
      });

      setTimeout(function () {
        fetch("/cart/add.js", {
          method: "POST",
          body: JSON.stringify(cartData),
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => {
            if (response.ok) {
              return response.json(); // Get the updated cart data
            } else {
              console.error("Failed to add products to cart!");
              // return Promise.reject(new Error('Failed to add products'));
            }
          })
          .then((data1) => {
            var data = data1.items[0];
            console.log("data", data);
            const event = new CustomEvent("quick-cart:updated", { data1 });
            document.dispatchEvent(event);
          })
          .catch((error) => {});
        setTimeout(function () {
          const event1 = new CustomEvent("quick-cart:updated");
          document.dispatchEvent(event1);
          $(".quick-cart__wrapper").addClass("active");
        }, 1000);
        setTimeout(function () {
          var eve = new CustomEvent("quick-cart:updated");
          document.dispatchEvent(eve);
        }, 2000);
      }, 1000);
    });
  });

  $(".accordion.tab-detail").click(function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      var p = $(this).next();
      $(p).removeClass("active");
      setTimeout(function () {
        $(p).css("height", "0px");
      }, 500);
    } else {
      $(this).addClass("active");
      var p = $(this).next();
      $(p).addClass("active");
      setTimeout(function () {
        $(p).css("height", "auto");
      }, 500);
    }
  });
  $("body").on("click", ".index-product-video-img", function (e) {
    e.preventDefault();
    console.log("hii");
    $(".video-popup-section").addClass("video-popup-section-active");

    var d = $(this).data("urls");

    var vid = d.split(" - ");
    var h = "";
    $(vid).each(function (i, d) {
      if (d != "" && d.indexOf("mp4") != -1) {
        $("#vid-popup").attr("src", d);
        // $("#vid-popup")[0].load();
        $("#vid-popup").trigger("play");
      } else if (d != "" && d.indexOf("mov") != -1) {
        $("#vid-popup").attr("src", d);
        // $("#vid-popup")[0].load();
        $("#vid-popup").trigger("play");
      }
    });
  });

  $(".video-close-button").click(function () {
    $("#vid-popup").attr("src", "");
    $(".video-popup-section").removeClass("video-popup-section-active");
  });

  $(".btn-view-details").click(function (e) {
    e.preventDefault();
    var id = $(this).data("id");
    $(".popup-upsell-wrapper[data-id='" + id + "']").addClass("active");
    $(".overlay-upsell").addClass("active");
  });
  $(".overlay-upsell").click(function (e) {
    e.preventDefault();
    $(".popup-upsell-wrapper").removeClass("active");
    $(".overlay-upsell").removeClass("active");
  });
  $(".close-btn-upsell").click(function (e) {
    e.preventDefault();
    $(".popup-upsell-wrapper").removeClass("active");
    $(".overlay-upsell").removeClass("active");
  });

  var s = parseInt($(".index-prd-video-slide").data("size"));
  var md = 1;
  var sm = 1;
  var lg = 1;
  if (s >= 3) {
    lg = 3;
  } else {
    lg = 3;
  }
  if (s >= 4) {
    sm = 4;
  } else {
    sm = 4;
  }
  if (s >= 7) {
    md = 7;
  } else {
    md = 7;
  }
  if (lg >= 1) {
    // $(".index-prd-video-slide").slick({
    //   infinite: true,
    //   slidesToShow: lg,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   dots: false,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: lg,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: md,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 560,
    //       settings: {
    //         slidesToShow: sm,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: sm,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // });
  }

  $(".blog-post-wrapper-design-2").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
const element = document.getElementById("notify_button");
if (element) {
  element.addEventListener("click", function () {
    var pid = document.getElementById("notify_button").dataset.prdid;
    var email = document.getElementById("notify_email").value;
    var vid = parseInt(document.getElementById("variant-selector").value);
    console.log(email);
    console.log(vid);
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: "NxHZVf",
        email: email,
        variant: vid,
        platform: "shopify",
      },
      success: function (response) {
        console.log(response);
      },
      error: function (response) {
        console.log(response);
      },
    });
    $(".notify-main").hide();
    $(".thank-msg").show();
  });
}
